import React, { useContext, useEffect } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { DropsContext } from 'contexts/DropsContext';
import { NotificaçõesContext } from 'contexts/NotificaçõesContext';
import Navbar from 'components/Navbar';
import Routes from 'routes';

const styles = {
  main: {
    height: '100vh',
  },
  container: {
    padding: '88px 24px 0 24px',
  },
};

const App = () => {
  const { getDrops } = useContext(DropsContext);
  const { getNotifications } = useContext(NotificaçõesContext);

  useEffect(() => {
    getNotifications();
    getDrops([
      'Entidade',
      'EntidadeTipo',
      'Filial',
      'FormaDePagamento',
      'Logo',
      'Marca',
      'Produto',
      'ProdutoServico',
      'UnidadeMedida',
      'Users',
    ]);
  }, []);

  return (
    <div style={styles.main}>
      <Navbar />
      <Scrollbars>
        <div style={styles.container}>
          <Routes />
        </div>
      </Scrollbars>
    </div>
  );
};

export default App;
